import { ForwardLinkComponent } from './dialogs/forward-link/forward-link.component';
import { PasswordRecoveryComponent } from './dialogs/password-recovery/password-recovery.component';
import { ContactoComponent } from './dialogs/contacto/contacto.component';
import { I18nModule } from './../i18n/i18n.module';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '@app/material.module';
import { LoaderComponent } from './loader/loader.component';
import { HeaderNoauthComponent } from './header-noauth/header-noauth.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { CondicionesComponent } from './dialogs/condiciones/condiciones.component';
import { SessionComponent } from './dialogs/session/session.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaswordDialogComponent } from './dialogs/password/password-dialog.component';
import { ResponseDialogComponent } from './dialogs/response/response-dialog.component';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { YearMonthDirective } from './directives/year-month.directive';
import { YearDirective } from './directives/year.directive';
import { YearMonthFullDirective } from './directives/year-month-full.directive';
import { TestRequestDialogComponent } from './dialogs/test-request/test-request.component';
import { LoaderGenericComponent } from './loader-generic/loader-generic.component';
import { A11yModule } from '@angular/cdk/a11y';
import { PasswordErrorDialogComponent } from './dialogs/password-error/password-error.component';
import { SearchUsersComponent } from './dialogs/search-users/search-users.component';
import { SmsComponent } from './dialogs/SMS/sms.component';
import { WhitelistDialogComponent } from './dialogs/whitelist/whitelist-dialog.component';
import { UpdateComponent } from './update/update.component';
import { TransformNumberPipe } from './pipes/transform-number.pipe';
import { InfoDialog } from './dialogs/info/info.component';
import { WhitelistResponseDialog } from './dialogs/whitelist-response/whitelist-response-dialog.component';
import { DetailEcommerceDialog } from './dialogs/detail-ecommerce/detail-ecommerce.component';
import { DetailTpvEcommerceDialog } from './dialogs/detail-tpv-ecommerce/detail-tpv-ecommerce.component';
import { SelectColumnsComponent } from './dialogs/select-columns/select-columns.component';
import { DetailSignatureDigitalDialog } from './dialogs/detail-signatureDigital/detail-signature-digital.component';
import { TransformEuroCurrencyPipe } from './pipes/transform-string-currency.pipe';
import { TransformRemoveFormatPipe } from './pipes/transform-remove-format.pipe';
import { DragDropUpdateComponent } from './drag-drop-update/drag-drop-update.component';
import { FileDragNDropDirective } from './directives/file-drag-n-drop.directive';
import { DatepickerUtilsService } from './services/utils/datepicker-utils.service';
import { YearMonthDayFullDirective } from './directives/year-month-day.directive';
import { CustomSelectSearchComponent } from './custom-select-search/custom-select-search';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { from } from 'rxjs';
import { PasswordExpiredDialogComponent } from './dialogs/password-expired/password-expired.component';
import { LoadingExcelComponent } from './dialogs/loading-excel/loading-excel.component';

@NgModule({
  imports: [
    FlexLayoutModule,
    MaterialModule,
    CommonModule,
    I18nModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatMomentDateModule,
    A11yModule,
    NgxMatSelectSearchModule,
    MatSelectInfiniteScrollModule,
  ],
  declarations: [
    LoaderComponent,
    HeaderComponent,
    ContactoComponent,
    FooterComponent,
    HeaderNoauthComponent,
    CondicionesComponent,
    SessionComponent,
    SmsComponent,
    PaswordDialogComponent,
    ResponseDialogComponent,
    YearMonthDirective,
    YearDirective,
    YearMonthFullDirective,
    YearMonthDayFullDirective,
    FileDragNDropDirective,
    TestRequestDialogComponent,
    LoaderGenericComponent,
    SelectColumnsComponent,
    PasswordErrorDialogComponent,
    PasswordExpiredDialogComponent,
    LoadingExcelComponent,
    WhitelistDialogComponent,
    UpdateComponent,
    TransformNumberPipe,
    InfoDialog,
    SearchUsersComponent,
    WhitelistResponseDialog,
    DetailEcommerceDialog,
    DetailTpvEcommerceDialog,
    DetailSignatureDigitalDialog,
    PasswordRecoveryComponent,
    TransformEuroCurrencyPipe,
    DragDropUpdateComponent,
    CustomSelectSearchComponent,
    ForwardLinkComponent,
    ForwardLinkComponent,
    CustomSelectSearchComponent,
    TransformRemoveFormatPipe,
  ],
  exports: [
    LoaderComponent,
    HeaderComponent,
    FooterComponent,
    HeaderNoauthComponent,
    CondicionesComponent,
    SessionComponent,
    SmsComponent,
    PaswordDialogComponent,
    ResponseDialogComponent,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    YearMonthDirective,
    YearDirective,
    YearMonthFullDirective,
    YearMonthDayFullDirective,
    FileDragNDropDirective,
    LoaderGenericComponent,
    SelectColumnsComponent,
    WhitelistDialogComponent,
    UpdateComponent,
    TransformNumberPipe,
    SearchUsersComponent,
    DetailEcommerceDialog,
    DetailTpvEcommerceDialog,
    DetailSignatureDigitalDialog,
    PasswordRecoveryComponent,
    TransformEuroCurrencyPipe,
    DragDropUpdateComponent,
    ForwardLinkComponent,
    CustomSelectSearchComponent,
  ],
  providers: [DatePipe, DatepickerUtilsService, ForwardLinkComponent, TransformRemoveFormatPipe],
})
export class SharedModule {}

export * from './services/print/print.store';
export * from './services/print/print-api.service';
